enum MedicationLegalStatus {
    ControlledDrugPartII = "1",
    ControlledDrugPartI = "2",
    ControlledDrugPartIReportable = "3",
    NarcoticDrug = "4",
    NarcoticDrugReportable = "5",
    NarcoticPreparation = "6",
    NarcoticPreparationOverTheCounter = "7",
    ControlledDrugPartIII = "9",
    ProfessionalAct = "A",
    TargetedSubstance = "B",
    PrescriptionScheduleF = "P",
    PrescriptionSchedule1 = "U",
    OverTheCounterFreeSale = "G",
    Homeopathy = "H",
    OverTheCounterSchedule2 = "D",
    OverTheCounterSchedule3 = "T"
}

class MedicationLegalStatusHelper {
    private static readonly narcoticStatus = [
        MedicationLegalStatus.NarcoticDrug,
        MedicationLegalStatus.NarcoticDrugReportable,
        MedicationLegalStatus.NarcoticPreparation,
        MedicationLegalStatus.NarcoticPreparationOverTheCounter
    ];

    public static isNarcotic(legalStatus: MedicationLegalStatus | string): boolean {
        return this.narcoticStatus.includes(legalStatus as MedicationLegalStatus);
    }
}

export { MedicationLegalStatus, MedicationLegalStatusHelper };
